import Page from './Page';
import InstantSearch from 'vue-instantsearch';
import Articles from '../pages/articles/vue/Articles';
import CurrencySwitcher from '../components/currency-switcher';

import MixinVue from '../mixins/WexVue';

/**
 * Site specific stuffs.
 */
export default class extends Page {
    static getPageLevelMixins() {
        return {
            MixinVue,
        };
    }

    init() {
        super.init();

        // If there is already a query string we dont touch it
        // since algolia can use it to set filters
        const queryString = window.location.search;
        if (queryString == undefined || queryString == '') {
            this.presetSearchParameters();
        }

        this.initSearch();
    }

    presetSearchParameters() {
        // Override if needed
    }

    initSearch() {
        this.initComponent('#currency-switcher', CurrencySwitcher);

        this.app.lib.vue.use(InstantSearch);

        // Custom vue builder according Algolia documentation.
        new this.app.lib.vue({
            el: document.getElementById('articles'),
            render: (h) => h(Articles),
        });

        // Prevent filter dropdown to close when clicking inside the dropdown-menu
        this.app.lib
            .jQuery('body')
            .on('click', '.dropdown-menu-keep-open', (event) => {
                event.stopPropagation();
            });
    }
}
